module.exports = __webpack_public_path__ + "static/logo-b8aa458980096841e7c78017c4ed2523.svg";